import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1068.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M5150 10134 c-305 -15 -421 -29 -700 -85 -150 -31 -236 -50 -305 -69
-22 -6 -57 -15 -78 -21 -105 -26 -418 -136 -513 -180 -34 -16 -65 -29 -68 -29
-30 0 -448 -214 -581 -298 -22 -14 -50 -31 -61 -37 -41 -21 -228 -151 -358
-249 -206 -155 -291 -230 -496 -436 -200 -200 -281 -293 -428 -489 -191 -254
-290 -411 -433 -686 -453 -871 -624 -1844 -499 -2840 21 -166 91 -509 137
-665 39 -137 144 -443 177 -517 20 -45 36 -84 36 -87 0 -13 164 -342 222 -447
433 -772 1094 -1427 1878 -1859 73 -40 357 -180 365 -180 3 0 30 -12 62 -26
79 -36 106 -47 193 -79 148 -54 176 -64 260 -89 47 -14 99 -30 115 -35 53 -17
335 -83 425 -100 461 -85 1014 -105 1425 -50 188 25 293 40 330 49 22 5 78 16
125 25 80 16 225 51 315 76 49 14 332 107 360 118 11 5 79 32 150 61 277 112
578 272 820 433 109 73 293 203 305 217 3 3 41 34 85 70 44 35 82 67 85 70 3
3 48 43 100 90 155 139 308 297 479 495 85 99 261 344 366 510 341 539 578
1171 679 1815 41 266 50 392 50 730 0 375 -15 567 -64 825 -6 28 -19 95 -29
150 -56 290 -163 630 -298 945 -36 82 -189 389 -230 460 -126 218 -294 466
-423 624 -405 497 -900 913 -1445 1212 -117 64 -324 163 -440 210 -33 14 -70
29 -82 34 -238 101 -624 212 -918 265 -174 31 -201 35 -350 50 -242 25 -489
31 -745 19z m-316 -2732 c64 -35 98 -89 104 -165 5 -63 2 -76 -109 -547 -27
-114 -45 -192 -63 -270 -8 -36 -31 -132 -51 -215 -19 -82 -40 -172 -46 -200
-6 -27 -20 -87 -32 -132 -19 -80 -21 -83 -52 -89 -47 -8 -71 8 -78 53 -4 21
-4 344 -2 718 6 755 5 752 69 814 43 42 128 73 176 65 19 -3 57 -18 84 -32z
m-1203 -196 c114 -35 144 -70 190 -221 39 -130 89 -292 132 -430 19 -60 42
-135 51 -165 29 -101 136 -454 162 -535 37 -117 37 -144 -3 -167 -18 -11 -40
-17 -50 -14 -10 4 -42 48 -70 99 -29 50 -59 103 -67 117 -127 214 -166 281
-166 284 0 3 -29 53 -64 113 -35 59 -96 164 -136 233 -40 69 -104 179 -142
245 -39 66 -77 137 -84 159 -42 116 24 243 146 281 57 17 47 17 101 1z m613
-185 c21 -5 51 -22 67 -37 47 -45 59 -99 59 -271 0 -85 4 -195 9 -246 6 -51
12 -209 15 -352 3 -143 8 -274 12 -292 5 -26 2 -34 -18 -47 -13 -8 -39 -17
-58 -18 -32 -3 -35 0 -48 37 -8 22 -20 63 -27 90 -18 70 -75 266 -85 290 -4
11 -16 49 -25 85 -10 36 -26 92 -36 125 -9 33 -29 101 -44 150 -14 50 -38 128
-52 174 -14 46 -26 110 -26 142 -1 50 2 62 29 96 34 41 70 63 124 74 50 10 60
10 104 0z m997 -65 c74 -31 109 -83 109 -162 0 -44 -12 -70 -132 -294 -20 -36
-61 -114 -93 -175 -32 -60 -83 -157 -114 -215 -31 -58 -85 -160 -121 -228 -43
-82 -72 -124 -85 -127 -33 -8 -80 9 -83 31 -2 11 11 76 28 144 17 69 35 143
40 165 5 22 28 112 51 200 22 88 45 178 49 200 18 80 88 351 100 380 15 39 48
74 85 91 35 17 114 12 166 -10z m542 -37 c82 -22 149 -114 150 -204 1 -82 -30
-127 -218 -320 -90 -93 -260 -271 -415 -435 -305 -324 -284 -304 -312 -297
-14 4 -36 16 -49 26 -19 16 -22 23 -13 38 6 10 37 68 69 128 32 61 78 146 103
190 24 44 58 105 75 135 16 30 50 90 74 133 57 101 74 132 178 322 121 222
131 235 194 268 58 29 103 33 164 16z m-2434 -335 c60 -24 109 -90 344 -464
74 -118 171 -273 217 -345 123 -194 118 -179 76 -221 -24 -24 -40 -33 -50 -27
-17 10 -86 75 -411 388 -137 132 -281 270 -319 305 -83 79 -106 121 -106 192
0 44 6 61 34 99 36 49 103 89 148 89 15 0 45 -7 67 -16z m-585 -139 c41 -12
72 -33 133 -88 98 -89 312 -287 455 -422 58 -55 198 -185 311 -290 113 -104
208 -196 211 -203 8 -18 -31 -92 -48 -92 -12 0 -48 19 -273 148 -39 23 -89 51
-110 63 -144 81 -502 285 -523 298 -14 8 -45 26 -70 40 -82 44 -285 164 -302
178 -51 45 -74 172 -44 244 20 48 74 96 132 119 60 23 64 24 128 5z m3197 -97
c94 -32 167 -138 154 -224 -8 -58 -48 -103 -128 -144 -34 -18 -73 -40 -87 -50
-14 -9 -63 -37 -110 -61 -47 -24 -107 -57 -135 -74 -27 -18 -57 -35 -65 -38
-19 -9 -68 -36 -280 -156 -122 -69 -139 -75 -167 -65 -15 5 -34 22 -43 37
l-15 28 195 191 c107 105 269 264 360 353 145 143 200 187 260 208 23 8 24 8
61 -5z m-3045 -644 c71 -36 161 -83 199 -104 39 -20 124 -65 190 -100 66 -34
147 -77 180 -95 33 -18 113 -60 177 -94 65 -35 121 -67 124 -73 9 -14 -25 -98
-39 -98 -15 1 -75 14 -157 34 -36 9 -94 24 -130 32 -36 8 -81 19 -100 24 -19
5 -82 21 -140 34 -482 114 -511 122 -569 150 -60 28 -81 66 -81 141 1 88 42
167 105 199 58 30 102 21 241 -50z m5671 -190 c70 -22 92 -33 153 -78 62 -45
76 -60 123 -131 98 -147 108 -321 29 -484 -47 -97 -125 -174 -229 -227 l-78
-39 -135 0 -135 0 -79 40 c-179 89 -276 248 -276 451 0 138 42 236 145 340 69
69 102 90 200 125 65 24 215 25 282 3z m-6127 -182 c25 -5 77 -17 115 -26 39
-9 88 -20 110 -25 22 -5 74 -17 115 -26 41 -9 91 -21 110 -25 19 -4 69 -16
110 -25 41 -9 91 -21 110 -25 19 -4 69 -16 110 -25 81 -18 119 -27 190 -43 25
-6 77 -18 115 -27 39 -9 91 -20 117 -25 79 -14 90 -24 86 -78 l-3 -47 -135 -6
c-74 -4 -403 -7 -731 -8 l-595 -1 -51 25 c-32 16 -61 41 -79 67 -27 38 -29 49
-29 129 0 82 2 89 30 124 17 20 48 48 70 61 35 20 50 23 115 20 41 -2 95 -8
120 -14z m2234 -148 c13 -13 16 -44 16 -178 0 -183 -2 -189 -67 -184 l-38 3
-5 83 -5 84 -33 -67 c-32 -65 -33 -66 -69 -63 -34 3 -39 7 -69 68 l-33 65 0
-75 c-1 -85 -10 -100 -57 -100 -52 0 -55 11 -52 196 l3 169 57 3 57 3 46 -92
c26 -50 49 -89 52 -86 3 3 24 43 46 89 40 80 43 83 82 89 22 3 43 7 47 8 4 0
14 -6 22 -15z m291 -6 c44 -15 53 -34 35 -79 -12 -29 -37 -38 -56 -19 -14 14
-104 25 -104 13 0 -15 21 -29 55 -37 100 -24 148 -90 115 -163 -23 -52 -58
-68 -144 -68 -57 0 -80 5 -113 24 -45 26 -51 42 -31 86 11 24 41 34 52 16 9
-14 95 -41 111 -34 38 14 8 40 -71 62 -108 29 -121 150 -21 200 46 23 100 23
172 -1z m320 1 c30 -11 55 -25 55 -30 0 -19 -29 -79 -38 -79 -5 0 -26 7 -45
15 -49 20 -89 20 -85 -1 2 -10 26 -23 62 -34 69 -22 103 -51 112 -95 7 -39
-15 -88 -50 -111 -58 -37 -189 -26 -243 20 -28 24 -28 24 -10 60 16 34 39 46
52 27 3 -5 28 -17 55 -26 40 -13 54 -14 65 -5 20 17 4 37 -38 46 -47 10 -105
41 -117 63 -26 50 -4 122 44 145 67 31 109 32 181 5z m692 -8 c7 -9 13 -21 13
-27 0 -11 18 -55 67 -164 67 -149 67 -160 -2 -160 -41 0 -48 4 -63 30 -16 28
-20 30 -82 30 -62 0 -66 -2 -82 -30 -15 -26 -23 -30 -62 -30 -25 0 -48 5 -51
10 -8 14 132 341 154 358 21 17 91 6 108 -17z m394 8 c5 -8 8 -27 7 -44 -3
-28 -6 -30 -53 -35 l-50 -5 -5 -135 -5 -135 -44 -3 c-28 -2 -47 1 -52 10 -5 7
-9 70 -9 140 l0 127 -52 3 -53 3 -3 38 c-4 49 5 52 174 51 104 -1 138 -4 145
-15z m570 10 c83 -26 95 -45 63 -94 -19 -29 -31 -31 -70 -10 -37 19 -84 20
-84 1 0 -9 25 -23 64 -36 82 -27 111 -57 111 -115 0 -104 -137 -148 -265 -86
-29 14 -40 16 -37 7 9 -22 -14 -36 -60 -36 -37 0 -44 4 -58 30 -15 29 -18 30
-83 30 -64 0 -68 -1 -84 -30 -14 -25 -23 -30 -56 -30 -70 0 -69 10 25 220 12
25 31 69 43 98 l23 53 55 -3 56 -3 61 -147 60 -147 18 34 c9 19 21 35 26 35 5
0 34 -12 65 -26 56 -25 96 -26 96 0 0 14 -41 36 -66 36 -31 0 -95 41 -105 68
-14 36 -4 91 21 116 38 38 121 54 181 35z m220 -120 c4 -105 6 -122 23 -135
29 -21 63 -17 80 8 12 17 16 49 16 134 0 61 2 113 5 115 2 3 26 3 52 -1 l48
-5 0 -132 c0 -144 -5 -160 -69 -207 -42 -32 -148 -30 -198 4 -56 37 -69 81
-66 220 l3 115 40 5 c22 3 45 4 51 2 8 -2 13 -45 15 -123z m-1508 88 c52 -40
71 -80 70 -155 0 -55 -4 -68 -30 -100 -53 -65 -83 -76 -208 -77 l-110 0 -3
170 c-1 93 0 176 3 183 4 11 29 13 123 11 112 -4 121 -6 155 -32z m2063 0 c28
-32 32 -82 9 -114 -14 -20 -13 -25 10 -59 18 -26 23 -44 19 -63 -20 -82 -48
-96 -198 -96 l-121 0 -3 183 -2 184 131 -4 c129 -3 131 -3 155 -31z m-3970
-355 c20 -31 26 -79 12 -88 -18 -12 -189 -63 -211 -64 -9 0 -25 -4 -35 -9 -9
-5 -44 -17 -77 -26 -33 -9 -89 -25 -125 -35 -36 -11 -90 -26 -120 -34 -136
-37 -375 -107 -436 -126 -47 -15 -137 -12 -174 6 -52 26 -83 106 -78 199 3 62
7 78 28 101 53 57 74 60 470 73 201 7 392 13 425 15 33 1 116 3 185 4 111 2
126 0 136 -16z m105 -233 l23 -32 -27 -21 c-14 -12 -61 -43 -104 -69 -43 -27
-190 -118 -328 -204 -137 -85 -272 -169 -300 -185 -27 -16 -70 -42 -95 -58
-25 -16 -63 -40 -85 -53 -22 -13 -63 -39 -92 -57 -84 -53 -146 -69 -208 -55
-67 16 -99 38 -137 93 -27 39 -31 53 -31 111 0 132 62 196 238 246 33 9 71 21
85 25 14 5 61 20 105 33 44 13 139 43 210 65 72 22 171 52 220 67 50 15 153
46 230 70 269 84 254 83 296 24z m1418 -59 c39 -40 50 -103 26 -154 -38 -79
-144 -102 -210 -45 -19 17 -35 36 -35 43 0 6 22 34 49 63 27 28 61 68 76 87
33 44 54 45 94 6z m-1301 -99 c17 -17 32 -36 32 -43 0 -15 -23 -40 -279 -308
-102 -107 -238 -249 -301 -316 -135 -142 -168 -164 -239 -164 -80 0 -149 43
-177 109 -20 48 -17 88 10 146 31 67 62 90 371 280 88 53 171 105 185 114 14
10 32 20 40 24 8 4 80 48 160 97 80 50 149 90 155 90 6 0 25 -13 43 -29z
m1125 -187 c84 -84 102 -118 93 -168 -14 -73 -123 -126 -197 -96 -49 21 -52
28 -99 244 -11 51 -8 56 47 88 34 19 52 24 65 17 9 -5 50 -43 91 -85z m-965
66 c18 -11 35 -27 38 -35 3 -8 -41 -105 -99 -217 -57 -112 -148 -288 -201
-393 -110 -215 -146 -259 -221 -270 -56 -9 -93 0 -147 34 -38 24 -47 37 -62
85 -31 98 -9 148 120 282 38 39 170 175 292 302 123 128 229 232 235 232 7 0
27 -9 45 -20z m219 -87 c12 -3 24 -11 26 -18 5 -12 -15 -120 -79 -420 -20 -93
-40 -190 -44 -216 -16 -91 -32 -131 -65 -167 -33 -36 -35 -37 -104 -36 -62 0
-76 4 -113 30 -53 37 -69 70 -69 139 0 56 0 57 111 250 9 17 29 53 45 80 69
124 210 361 220 368 5 4 19 5 30 1 11 -3 30 -8 42 -11z m499 -63 c119 -271
134 -312 134 -358 0 -27 -7 -57 -16 -70 -25 -36 -87 -62 -146 -62 -45 0 -60 5
-88 29 l-35 29 -3 222 c-2 123 -1 233 2 245 6 24 54 45 95 42 20 -2 30 -15 57
-77z m-254 -50 c22 -249 36 -511 28 -544 -12 -53 -35 -84 -76 -101 -47 -20
-78 -19 -139 3 -62 22 -95 66 -95 126 0 23 14 88 31 146 16 58 41 146 55 195
14 50 29 104 34 120 5 17 14 50 21 75 17 65 25 71 83 68 l51 -3 7 -85z"
          />
          <path
            d="M5926 5042 c-3 -5 -10 -21 -15 -36 -10 -24 -9 -26 19 -26 27 0 28 1
20 31 -11 37 -16 44 -24 31z"
          />
          <path
            d="M6530 5026 c-15 -40 -13 -46 16 -46 24 0 25 3 19 28 -10 42 -23 49
-35 18z"
          />
          <path
            d="M5504 5086 c-3 -8 -4 -48 -2 -88 l3 -73 36 -3 c52 -4 89 28 89 78 0
21 -3 46 -6 55 -14 36 -109 61 -120 31z"
          />
          <path
            d="M7562 5078 c3 -20 8 -23 43 -20 46 4 49 6 42 27 -4 10 -20 15 -47 15
-37 0 -41 -2 -38 -22z"
          />
          <path
            d="M7560 4940 c0 -28 2 -30 39 -30 22 0 44 6 51 15 19 23 -5 45 -51 45
-37 0 -39 -2 -39 -30z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
